import React, { useState } from 'react'

import { NavLink, Link, useLocation } from 'react-router-dom';
import Icon from 'react-icons-kit';
import { comments } from 'react-icons-kit/fa';
import { user as userIcon } from 'react-icons-kit/feather';
import { statsBars2 } from 'react-icons-kit/icomoon';
import { Users, LogOut  } from 'lucide-react';
// import { CiLogout } from "react-icons";
import './indexStyle.scss';
import Requests from "../../utils/Requests/Index"
import NavBar from '../NavBar/MyBiyesadi';
import MatchesNavBar from '../NavBar/Matches';
import ConnectionNavBar from '../NavBar/Connection';
import SearchNavBar from '../NavBar/Search';
import { Images } from '../../utils/Images';

const LeftSidebar = () => {
  const location = useLocation();
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

  const doLogout = async () => {
        try {
            await Requests.Auth.Logout(header);
            localStorage.clear()
            window.location.reload()
        } catch (err) {
            if (err) console.log(err);
        }
    }

  return (
    <div className="dashboard-container">
      <aside className="sidebar">

        {/* Logo */}
        <div className="logo-container border-bottom-1">
          <Link to="/">
            <img src={Images.Logo} alt="Logo" className="img-fluid" />
          </Link>
        </div>

        {/* Navigation */}
        <div className="sidebar-nav">
          <div className="nav-group">

            {/* ICON MENU */}
            <div className="sidebar-icon-only">

              <NavLink
                to="/my-ghotokbari"
                className={({ isActive }) =>
                  `icon-box ${isActive ? 'active' : ''}`
                }
              >
                <Icon icon={userIcon} size={20} />
              </NavLink>

              <NavLink
                to="/matches"
                className={({ isActive }) =>
                  `icon-box ${isActive ? 'active' : ''}`
                }
              >
                <Users size={20} />
              </NavLink>

              <NavLink
                to="/connection"
                className={({ isActive }) =>
                  `icon-box ${isActive ? 'active' : ''}`
                }
              >
                <Icon icon={comments} size={20} />
              </NavLink>

              <NavLink
                to="/timeline"
                className={({ isActive }) =>
                  `icon-box ${isActive ? 'active' : ''}`
                }
              >
                <Icon icon={statsBars2} size={20} />
              </NavLink>

              <NavLink
                onClick={doLogout}
                className={({ isActive }) =>
                  `icon-box ${isActive ? '' : ''}`
                }
              >
                <LogOut size={20} />
              </NavLink>

            </div>

            {/* RIGHT SIDE TEXT NAV */}
            <div className="nav-items">

              {/* My Biyesadi */}
              {location.pathname.startsWith('/my-ghotokbari') && <NavBar />}

              {/* Matches */}
              {location.pathname.startsWith('/matches') && <MatchesNavBar />}

              {/* Connection */}
              {location.pathname.startsWith('/connection') && <ConnectionNavBar />}

              {/* Search */}
              {location.pathname.startsWith('/search') && <SearchNavBar />}

            </div>

          </div>
        </div>

      </aside>
    </div>
  );
};

export default LeftSidebar;
